import { render } from "./Cart.vue?vue&type=template&id=1c9e0cab&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=1c9e0cab&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9e0cab"]])

export default __exports__